import React, { useRef, useState, useEffect, createRef } from "react";
import * as R from "ramda";

import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle";

import { getLetterInformationByLetterId, updateLetterById, validateLetter, abandonLetter } from "../../../../actions/facilita-api";
import { Document, Page, pdfjs } from "react-pdf";
import * as urls from "../../../../constants/webapi/facilita";
import { FrenchTypes, PensionProfessionalCategoryMapping } from "../../../../constants/utils/connectionTypes";
import { LetterProgressStage } from "../../../../constants/utils/letterProgressStage";
import { useDispatch } from "react-redux";
import $ from "jquery";
import * as loadings from "../../../../constants/loadings/facilita/deathDeclaration";

import { uploadDocument, downloadDocument, deleteDocument, downloadLetter } from "../../../../actions/facilita-api";

import { isValidURL } from "../../../../utils/misc";

import contriesList from "iso-3166-1-alpha-2";
import previewPdf from "./../../../../assets/images/placeholder/pdf-placeholder.jpg";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const ModalValidation = ({ service, userLetters, serviceDatas, files, userId, isLoading, setIsLoadingLetter, isLoadingLetters, declaringUserId, currentlyConnectedUserId, hasDocumentSending, relocationData }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const dispatch = useDispatch();

	const [elementOnFocus, setElementOnFocus] = useState(0);
	const [elRefs, setElRefs] = useState([]);

	const [selectedServiceData, setSelectedServiceData] = useState(R.isNil(service) ? undefined : service.serviceDatas[0]);
	const [userLettersForServiceData, setUserLettersForServiceData] = useState(undefined);
	const [selectedUserLetter, setSelectedUserLetter] = useState(undefined);
	const [numPages, setNumPages] = useState(null);
	const [documentUrl, setDocumentUrl] = useState(undefined);
	const [lettersChoice, setLettersChoice] = useState({});

	//Files
	const [filesToUpload, setFilesToUpload] = useState({});

	const emailService = (service) => {
		const address = `${relocationData.newAddress.addressLine1}, ${relocationData.newAddress.postalCode} ${relocationData.newAddress.city}, ${countries.getName(relocationData.newAddress.country, "fr", { select: "official" })}`;
		const email = service.email;
		const subject = "Information de changement d'adresse";
		const body = `Madame, Monsieur,\n\nJe vous informe par la présente de mon changement d’adresse qui prendra effet à compter de la date du ${new Date(relocationData.effectiveMovingDate).toLocaleDateString("fr-FR", {
			day: "numeric",
			month: "numeric",
			year: "numeric",
		})}.\n\nJe vous remercie de bien vouloir prendre note de mes nouvelles coordonnées : ${address}.\n\nVeuillez agréer, Madame, Monsieur, l’expression de mes salutations distinguées.`;
		const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

		const link = document.createElement("a");
		link.href = mailtoLink; // URL to open
		link.target = "_blank"; // Open in new tab
		link.rel = "noopener noreferrer"; // Security attributes
		link.click();
	};
	useEffect(() => {
		if (!R.isNil(service)) {
			setSelectedServiceData(service.serviceDatas[0]);
			setElRefs((elRefs) => service.serviceDatas.map((_, i) => createRef()));
		}
	}, [service]);

	useEffect(() => {
		let cancelled = false;
		if (!R.isNil(selectedServiceData)) {
			let ul = userLetters.filter((l) => l.userServiceId === selectedServiceData.id);

			let promises = [];
			ul.forEach((l) => {
				promises.push(getLetterInformationByLetterId(l.letterId));
			});
			if (R.isEmpty(ul)) {
				return;
			}

			Promise.all(promises).then((letters) => {
				if (cancelled) return;
				for (let i = 0; i < letters.length; i++) {
					ul[i].letterTemplate = letters[i];
					if (!R.isEmpty(ul[i].letterTemplate.optionalData)) {
						ul[i].optionalDataform = React.createRef();
					}
					if (!R.isEmpty(ul[i].letterTemplate.optionalFiles)) {
						ul[i].optionalFilesform = React.createRef();
					}
				}

				const nextStageLetters = ul.filter((u) => u.letterProgressStage !== "Created");
				if (nextStageLetters.length === 0) {
					setUserLettersForServiceData(ul);
					if (R.isNil(selectedUserLetter) || ul.find((l) => l.id === selectedUserLetter.id) === undefined) setSelectedUserLetter(ul[0]);

					if (R.isEmpty(lettersChoice) || !Object.keys(lettersChoice).includes(ul[0]?.id)) {
						const initLettersChoice = {};
						ul.map((userLetter) => {
							if (userLetter.letterProgressStage === "Created") initLettersChoice[userLetter.id] = undefined;
						});
						setLettersChoice(initLettersChoice);
					}
				} else {
					setUserLettersForServiceData(ul);
					if (R.isNil(selectedUserLetter) || ul.indexOf(selectedUserLetter) === -1) {
						// Find the first letter that is not abandoned
						const firstNonAbandonedLetter = nextStageLetters.find(
							(letter) => letter.letterProgressStage !== "Abandonned"
						);
						// If there's a non-abandoned letter, select it; otherwise, select the first letter
						setSelectedUserLetter(firstNonAbandonedLetter || nextStageLetters[0]);
					}
				}
			});
		}
		return () => { cancelled = true; };
	}, [selectedServiceData, userLetters]);

	useEffect(() => {
		if (R.isNil(documentUrl) && !R.isNil(selectedUserLetter)) {
			setDocumentUrl({
				url: urls.letterContentUrlByletterId(selectedUserLetter.id),
				httpHeaders: {
					Authorization: "Bearer " + sessionStorage.getItem("access_token"),
				},
			});
		}
		if (!R.isNil(selectedUserLetter) && !R.isNil(documentUrl) && documentUrl.url !== urls.letterContentUrlByletterId(selectedUserLetter.id)) {
			setDocumentUrl({
				url: urls.letterContentUrlByletterId(selectedUserLetter.id),
				httpHeaders: {
					Authorization: "Bearer " + sessionStorage.getItem("access_token"),
				},
			});
			if (selectedUserLetter.letterProgressStage === "Created" && !R.isNil(selectedUserLetter.letterTemplate.optionalFiles)) {
				Object.keys(selectedUserLetter.letterTemplate.optionalFiles).map((key) => {
					const matchingFile = files.find((f) => f.fileType === key);
					if (!R.isNil(matchingFile)) {
						filesToUpload[key] = { ...matchingFile, name: matchingFile.fileName };
						setFilesToUpload(filesToUpload);
					}
				});
			}
		}
	}, [selectedUserLetter]);

	useEffect(() => {
		// Initialize all bootstrap
		const tooltipTriggerList = [...document.querySelectorAll('[data-toggle="tooltip"]')];
		[...tooltipTriggerList].map((tooltipTriggerEl) => {
			new Tooltip(tooltipTriggerEl);
		});
	}, []);

	// if (R.isNil(service)) {
	// 	return '';
	// }
	// if (R.isNil(service.serviceDatas)) {
	// 	return '';
	// }

	// if (R.isNil(userLettersForServiceData)) {
	// 	return '';
	// }

	// if (R.isNil(selectedUserLetter)) {
	// 	return '';
	// }

	return (
		<div className="modal fade px-0" id="validation" aria-labelledby="validationLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-dialog-scrollable container-modal">
				{!R.isNil(selectedUserLetter) && !R.isNil(userLettersForServiceData) && !R.isNil(service.serviceDatas) && !R.isNil(service) ? (
					<div className="modal-content bg-light">
						<div className="modal-header pb-0" data-dismiss="modal" aria-label="Close">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h5 className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="validationLabel">
									Validation des documents
								</h5>
							</div>
						</div>
						<div className="modal-body pb-0 scroll-default">
							<div className="row grid-sm grid-lg-2 align-items-center gx-3 grid-auto-scroll">
								{!R.isNil(selectedServiceData) && (R.isNil(selectedServiceData.urls) || R.isEmpty(selectedServiceData.urls)) && !R.isNil(selectedUserLetter) && !isValidURL(selectedUserLetter.letterTemplate.body) ? (
									<div className="col-12 col-lg">
										<div className="block mx-auto container-lg-copy">
											<div className="block sticky-auto t-auto-0 z-2 bg-light text-right pb-2 mx-n3 px-3">
												{!R.isNil(relocationData) && !R.isNil(selectedServiceData) && !R.isEmpty(selectedServiceData.email) && !R.isNil(selectedServiceData.email) && (
													<button
														className="btn btn-alert-info btn-if p-1 rounded border-none mr-2"
														type="button"
														onClick={(e) => {
															e.preventDefault();
															emailService(selectedServiceData);
														}}
														data-toggle="tooltip"
														data-placement="bottom"
														data-html="true"
														data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
														title="Veillez à avoir configuré votre application mail">
														<i className="btn-icon eva eva-email-outline btn-white-info text-info rounded btn-square"></i>
														<span className="btn-text px-3">Envoyer email</span>
													</button>
												)}
												<button
													className="btn btn-alert-info btn-if p-1 rounded border-none"
													type="button"
													onClick={(e) => {
														e.preventDefault();
														downloadLetter(selectedUserLetter.id);
													}}>
													<i className="btn-icon eva eva-download-outline btn-white-info text-info rounded btn-square"></i>
													<span className="btn-text px-3">Télécharger</span>
												</button>
											</div>
											<Document className="border-0 h-wide" file={documentUrl} loading={"Chargement..."} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
												{Array.apply(null, Array(numPages))
													.map((x, i) => i + 1)
													.map((page) => (
														<Page pageNumber={page} width={500} loading={"Chargement..."} key={"pdfviewer_page_" + page} className={"card paper-shadow mb-2 mx-auto align-items-center"} />
													))}
											</Document>
										</div>
									</div>
								) : (
									<div className="col-12 col-lg bg-gradient-primary rounded">
										<div className="flex-column px-3 h-lg-wide w-lg-screen mx-auto py-3">
											<div className="card border-0 rounded text-center paper-shadow my-auto">
												<div className="card-body bg-alert-gray rounded-top">
													<p className="fs-3">Ce service a été configuré avec les données suivantes :</p>
													<div className="alert text-left bg-white rounded-top-right-sm rounded-bottom-left-sm mb-0">
														<div className="row align-items-center gx-2">
															<div className="col-4">
																<h1 className="text-primary text-uppercase font-weight-bold fs-2 lh-1 ls-2 my-auto">Identifiant</h1>
															</div>
															<div className="col">
																<p className="my-auto">{selectedServiceData.payload.reference}</p>
															</div>
														</div>
													</div>
												</div>
												{!R.isNil(selectedUserLetter) && !isValidURL(selectedUserLetter.letterTemplate.body) ? (
													<div className="card-body">
														<p className="fs-3 o-80">{!R.isNil(relocationData) ? "Pour mettre à jour vos données dans l'espace personnel cliquer sur : " : "Pour valider la clôture de ce compte cliquer sur :"}</p>
														{Object.keys(selectedServiceData.urls).map((key, idx) => {
															return (
																<button
																	className="btn btn-info px-4 mb-1"
																	key={selectedServiceData.id + "_link_" + idx}
																	onClick={(e) => {
																		e.preventDefault();
																		window.open(selectedServiceData.urls[key], "_blank");
																	}}>
																	{key}
																</button>
															);
														})}
														<p className="o-40 fs-2 mt-3 mb-0">Ou copier et coller le(s) lien(s) ci-dessous:</p>
														{Object.keys(selectedServiceData.urls).map((key, idx) => {
															return (
																<>
																	<span className="btn-link fs-3 text-info">
																		<span className="text-dark">{key}:</span>{" "}
																		<a href={selectedServiceData.urls[key]} target="_blank" rel="noopener noreferrer">
																			{selectedServiceData.urls[key]}
																		</a>
																	</span>
																	<br />
																</>
															);
														})}
													</div>
												) : (
													<div className="card-body">
														<p className="fs-3 o-80">Veuillez accéder le lien ci-dessous : </p>
														<button
															className="btn btn-info px-4 mb-1"
															onClick={(e) => {
																e.preventDefault();
																window.open(selectedUserLetter.letterTemplate.body, "_blank");
															}}>
															Démarche en ligne
														</button>

														<p className="o-40 fs-2 mt-3 mb-0">Ou copier et coller le(s) lien(s) ci-dessous:</p>
														<span className="btn-link fs-3 text-info">
															<span className="text-dark">Démarche en ligne:</span>{" "}
															<a href={selectedUserLetter.letterTemplate.body} target="_blank" rel="noopener noreferrer">
																{selectedUserLetter.letterTemplate.body}
															</a>
														</span>
													</div>
												)}
											</div>
										</div>
									</div>
								)}
								<div className="col-12 col-lg h-100 pr-lg-3 order-first order-lg-last">
									<div className="accordion" id="accordionOptions">
										<div className="flex-row align-items-center sticky-auto t-auto-0 z-2 bg-light">
											{!R.isNil(service.serviceDatas) && service.serviceDatas.length > 1 && elementOnFocus > 0 ? (
												<button
													className="btn btn-icon btn-faded btn-square o-50 o-100--hover mr-2 d-none d-xl-unset"
													onClick={() => {
														let elemenetToFocus = elementOnFocus;
														if (elementOnFocus > 0) {
															elemenetToFocus = elementOnFocus - 1;
														}
														if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
															elRefs[elemenetToFocus].current.scrollIntoView({ behavior: "smooth" });
															elRefs[elemenetToFocus].current.click();
														}
														setElementOnFocus(elemenetToFocus);
													}}>
													<i className="eva eva-arrow-ios-back-outline align-middle h4 lh-solid m-auto"></i>
												</button>
											) : (
												""
											)}
											<div className="scroller-nav sticky-top bg-light">
												<nav className="nav py-2 flex-row align-items-center">
													{service.serviceDatas.map((serviceData, index) => {
														let name = serviceData.serviceName;
														if (serviceData.serviceType === FrenchTypes.activity) {
															name = serviceData.payload.companyName;
														} else if (serviceData.serviceType === FrenchTypes.otherActivity || serviceData.serviceType === FrenchTypes.locataire || serviceData.serviceType === FrenchTypes.ehpad) {
															name = serviceData.payload.name;
														} else if (serviceData.serviceType === FrenchTypes.pension) {
															let categories = Object.values(PensionProfessionalCategoryMapping[0].options).concat(Object.values(PensionProfessionalCategoryMapping[1].options)).concat(Object.values(PensionProfessionalCategoryMapping[2].options)).concat(Object.values(PensionProfessionalCategoryMapping[3].options));
															name = categories.find((c) => c.value === serviceData.payload.professionalCategory).title;
														} else if (serviceData.serviceType === FrenchTypes.socialSecurity) {
															name = "CPAM";
															if (
																serviceData.serviceName.toUpperCase().indexOf("MSA") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("CAMIEG") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("CNMSS") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("ENIM") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("CANSSM") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("CPRPSNCF") > -1 ||
																serviceData.serviceName.toUpperCase().indexOf("MGEN") > -1 
															) {
																name = serviceData.serviceName;
															}
														}

														if (serviceData.serviceId.startsWith("Custom")) {
															if (R.isNil(serviceData.customServiceDetails)) {
																const parentServiceDataId = serviceData.serviceId.replace("Custom", "");
																const parentServiceData = service.serviceDatas.find((s) => s.id === parentServiceDataId);
																name = parentServiceData.customServiceDetails.name;
															} else {
																name = serviceData.customServiceDetails.name;
															}
														}

														return (
															<button
																className={"btn btn-outline-primary rounded-max py-2 px-sm mr-1" + (selectedServiceData.id === serviceData.id ? " active" : "")}
																key={"service_" + index}
																onClick={(e) => {
																	setSelectedServiceData(serviceData);
																	setElementOnFocus(service.serviceDatas.indexOf(serviceData));
																}}
																ref={elRefs[index]}>
																{name}
															</button>
														);
													})}
												</nav>
											</div>
											{!R.isNil(service.serviceDatas) && service.serviceDatas.length > 1 ? (
												<button
													className={"btn btn-icon btn-faded btn-square o-50 o-100--hover ml-2"}
													onClick={() => {
														let elemenetToFocus = elementOnFocus;
														if (elementOnFocus < service.serviceDatas.length - 1) {
															elemenetToFocus = elemenetToFocus + 1;
														}
														if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
															elRefs[elemenetToFocus].current.scrollIntoView({ behavior: "smooth" });
															elRefs[elemenetToFocus].current.click();
														}
														setElementOnFocus(elemenetToFocus);
													}}>
													<i className="eva eva-arrow-ios-forward-outline align-middle h4 lh-solid m-auto"></i>
												</button>
											) : (
												""
											)}
										</div>

										{R.isNil(userLettersForServiceData) ? <p>CHARGEMENT</p> : ""}

										{userLettersForServiceData.map((userLetterForServiceData, index) => {
											if (userLetterForServiceData.letterProgressStage !== "Created") {
												return (
													<div className="card ml-nborder bg-none mt-3" key={"letter_" + userLetterForServiceData.id}>
														<div className="card-header py-0 pr-0 pl-gutter" id="headingOption3" role="button" onClick={() => setSelectedUserLetter(userLetterForServiceData)}>
															<div className="flex-row align-items-center">
																<h2 className="h4 font-weight-demi my-auto ml-border mr-1">
																	<i className={"btn p-border rounded-sm eva eva-arrow-ios-back-outline fs-4 align-middle mr-2 ml-ngutter" + (selectedUserLetter.id === userLetterForServiceData.id ? " text-white bg-secondary" : " o-40")}></i>
																	<span className="align-middle">{userLetterForServiceData.letterTemplate.name.substring(userLetterForServiceData.letterTemplate.name.indexOf("-") + 1)}</span>
																</h2>
																{/* <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button> */}
															</div>
															<hr className="mt-2 mb-0 border-gray" />
															{R.isEmpty(selectedServiceData.urls) || R.isNil(selectedServiceData.urls) ? (
																<div className="card mb-3">
																	<div className="card-body">
																		<div className="flex-column flex-md-row mb-3 mb-md-2 text-right">
																			<h5 className="h3 font-weight-bolder my-auto mr-2">Chronologie</h5>
																			{!R.isNil(userLetterForServiceData.postId) ? (
																				<p className="fs-3 my-auto ml-md-auto lh-title">
																					<span className="fs-2 lh-1 o-60">Numéro suivi postal: </span>
																					<br />
																					{userLetterForServiceData.postId}
																				</p>
																			) : (
																				""
																			)}
																		</div>
																		<hr />
																		{userLetterForServiceData.letterHistory.map((history, index) => {
																			return (
																				<p className="lead lh-title mb-auto" key={"history_" + index}>
																					<i className={"eva eva-radio-button-on mr-1 align-middle" + (index < userLetterForServiceData.letterHistory.length - 1 ? " text-gray" : " text-success")}></i>
																					<span className={"fs-3 align-middle" + (index < userLetterForServiceData.letterHistory.length - 1 ? " o-60" : "")}>
																						{history.date.substring(0, 10)}: {LetterProgressStage[history.letterProgressStage]} {!R.isNil(history.details) && history.details !== "" ? `(${history.details})` : ""}
																					</span>
																				</p>
																			);
																		})}
																	</div>
																</div>
															) : (
																""
															)}
														</div>
													</div>
												);
											}
											if (R.isNil(userLetterForServiceData.letterTemplate)) {
												return "";
											}
											//let letterChoice = lettersChoice.find(l => l.id === userLetterForServiceData.id);
											return (
												<div className="card ml-nborder bg-none mt-3" key={"letter_" + userLetterForServiceData.id}>
													<div className="card-header py-0 pr-0 pl-gutter" id="headingOption3" role="button" onClick={() => setSelectedUserLetter(userLetterForServiceData)}>
														<div className="flex-row align-items-center">
															<i className={"btn p-border rounded-sm eva eva-arrow-ios-back-outline fs-4 align-middle mr-2 ml-ngutter" + (selectedUserLetter.id === userLetterForServiceData.id ? " text-white bg-secondary" : " o-40")}></i>
															<div className="flex-column my-auto mr-3">
																<h2 className="h4 font-weight-demi my-auto ml-border">{userLetterForServiceData.letterTemplate.name.substring(userLetterForServiceData.letterTemplate.name.indexOf("-") + 1)}</h2>
																{selectedUserLetter.id === userLetterForServiceData.id ? (
																	<div className="block">
																		<p className="fs-2 rounded mb-0 mt-1 alert bg-primary text-white" style={{ whiteSpace: "pre-wrap" }}>
																			{selectedUserLetter.letterTemplate.popUp}
																		</p>
																		{/* <p className="px-2 py-1 rounded alert-info fs-2 mb-0 mt-1">{selectedUserLetter.letterTemplate.popUp}</p> */}
																	</div>
																) : (
																	""
																)}
															</div>
															{R.isNil(selectedServiceData.urls) || R.isEmpty(selectedServiceData.urls) ? (
																<div className="flex-row ml-auto align-items-center">
																	{/* <div className="form-inline mb-3"> */}
																	<div className="custom-control custom-radio custom-control-inline">
																		<input
																			required={lettersChoice[userLetterForServiceData.id] === undefined ? true : false}
																			type="radio"
																			id={userLetterForServiceData.id + "_Oui"}
																			name={userLetterForServiceData.id + "_Choice"}
																			onChange={() => {
																				const a = { ...lettersChoice };
																				a[userLetterForServiceData.id] = true;
																				const otherUserLetterId = Object.keys(lettersChoice).find((i) => i !== userLetterForServiceData.id);
																				if (
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("transfert") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						(Object.values(lettersChoice).every((v) => R.isNil(v)) || a[otherUserLetterId] === true)) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("avenant") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						(Object.values(lettersChoice).every((v) => R.isNil(v)) || a[otherUserLetterId] === true)) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("modification") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						(Object.values(lettersChoice).every((v) => R.isNil(v)) || a[otherUserLetterId] === true)) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("information") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("modification") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						(Object.values(lettersChoice).every((v) => R.isNil(v)) || a[otherUserLetterId] === true)) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résilitation de la mutuelle du défunt") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résilitation de la mutuelle du défunt et maintien pour le conjoint") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						(Object.values(lettersChoice).every((v) => R.isNil(v)) || a[otherUserLetterId] === true))
																				) {
																					if (!R.isNil(otherUserLetterId)) {
																						a[otherUserLetterId] = false;
																					}
																				}
																				setLettersChoice(a);
																			}}
																			className="custom-control-input"
																			checked={lettersChoice[userLetterForServiceData.id] === true}
																		/>
																		<label className="custom-control-label" htmlFor={userLetterForServiceData.id + "_Oui"}>
																			Oui
																		</label>
																	</div>
																	<div className="custom-control custom-radio custom-control-inline mr-0">
																		<input
																			required={lettersChoice[userLetterForServiceData.id] === undefined ? true : false}
																			type="radio"
																			id={userLetterForServiceData.id + "_Non"}
																			name={userLetterForServiceData.id + "_Choice"}
																			onChange={() => {
																				const a = { ...lettersChoice };
																				a[userLetterForServiceData.id] = false;
																				if (
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("transfert") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						Object.values(lettersChoice).every((v) => R.isNil(v))) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("avenant") > -1) && Object.keys(lettersChoice).length > 1 && Object.values(lettersChoice).every((v) => R.isNil(v))) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résiliation") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("modification") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						Object.values(lettersChoice).every((v) => R.isNil(v))) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("information") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("modification") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						Object.values(lettersChoice).every((v) => R.isNil(v))) ||
																					((userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résilitation de la mutuelle du défunt") > -1 || userLetterForServiceData.letterTemplate.name.toLowerCase().indexOf("résilitation de la mutuelle du défunt et maintien pour le conjoint") > -1) &&
																						Object.keys(lettersChoice).length > 1 &&
																						Object.values(lettersChoice).every((v) => R.isNil(v)))
																				) {
																					const otherUserLetterId = Object.keys(lettersChoice).find((i) => i !== userLetterForServiceData.id);
																					if (!R.isNil(otherUserLetterId)) {
																						a[otherUserLetterId] = true;
																					}
																				}
																				setLettersChoice(a);
																			}}
																			className="custom-control-input"
																			checked={lettersChoice[userLetterForServiceData.id] === false}
																		/>
																		<label className="custom-control-label" htmlFor={userLetterForServiceData.id + "_Non"}>
																			Non
																		</label>
																	</div>
																</div>
															) : (
																""
															)}

															{/* <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button> */}
														</div>
														<hr className="mt-2 mb-0 border-gray" />
													</div>
													{(!R.isNil(userLetterForServiceData.letterTemplate.optionalData) && !R.isEmpty(userLetterForServiceData.letterTemplate.optionalData)) || (!R.isNil(userLetterForServiceData.letterTemplate.optionalFiles) && !R.isEmpty(userLetterForServiceData.letterTemplate.optionalFiles)) ? (
														<div className={"card-body pl-gutter pr-0 collapse" + (lettersChoice[userLetterForServiceData.id] === true ? " show" : "")} id="accordionOption3" aria-labelledby="headingOption3" data-parent="#accordionOptions">
															{userLetterForServiceData.letterProgressStage === "Created" && !R.isNil(userLetterForServiceData.letterTemplate.optionalData) && !R.isEmpty(userLetterForServiceData.letterTemplate.optionalData) ? (
																<form className="card mb-3" noValidate ref={userLetterForServiceData.optionalDataform}>
																	<section className="card-body pb-0">
																		<h5 className="h4 text-uppercase text-secondary font-weight-black">Champs à compléter</h5>
																		{Object.keys(userLetterForServiceData.letterTemplate.optionalData).map((key, index) => {
																			if (userLetterForServiceData.letterTemplate.id.toUpperCase() === "852F8D6D-9740-4430-942B-3254D2FE94F1" && userLetterForServiceData.optionalData["Checkbox.UserToImmatriculate"] !== "true" && key.startsWith("UsersToImmatriculate")) {
																				return "";
																			} else {
																				return (
																					<div className="row gx-2 mt-2" key={index + userLetterForServiceData.id + "_optionalData_" + key}>
																						<div className="col-12 col-md">
																							<div className="form-group">
																								<label className="h6 font-weight-bolder my-auto" htmlFor={userLetterForServiceData.id + "_" + key}>
																									{userLetterForServiceData.letterTemplate.optionalData[key]}
																								</label>

																								{key.startsWith("Checkbox") ? (
																									<select
																										className="custom-select"
																										id={userLetterForServiceData.id + "_" + key}
																										value={userLetterForServiceData.optionalData[key] === "false" || userLetterForServiceData.optionalData[key] === "true" ? userLetterForServiceData.optionalData[key] : false}
																										onChange={(e) => {
																											setUserLettersForServiceData(
																												userLettersForServiceData.map((ul, index) => {
																													if (ul.id !== userLetterForServiceData.id) {
																														return ul;
																													}
																													let newOptionalData = { ...ul.optionalData };
																													newOptionalData[key] = e.target.value.toString();
																													return {
																														...ul,
																														optionalData: newOptionalData,
																													};
																												})
																											);
																										}}>
																										<option value={false}>Non</option>
																										<option value={true}>Oui</option>
																									</select>
																								) : (
																									<input
																										required
																										type="text"
																										className="form-control"
																										id={userLetterForServiceData.id + "_" + key}
																										value={userLetterForServiceData.optionalData[key] === userLetterForServiceData.letterTemplate.optionalData[key] ? "" : userLetterForServiceData.optionalData[key]}
																										onChange={(e) => {
																											setUserLettersForServiceData(
																												userLettersForServiceData.map((ul, index) => {
																													if (ul.id !== userLetterForServiceData.id) {
																														return ul;
																													}
																													let newOptionalData = { ...ul.optionalData };
																													newOptionalData[key] = e.target.value;
																													return {
																														...ul,
																														optionalData: newOptionalData,
																													};
																												})
																											);
																										}}
																									/>
																								)}

																								<div className="invalid-feedback">
																									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
																									<span className="align-middle text-dark o-70">Ce champ est requis</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				);
																			}
																		})}
																	</section>
																	<footer className="card-footer text-right">
																		<button
																			className="btn btn-sm btn-alert-info border-none loading-btn"
																			onClick={(e) => {
																				e.preventDefault();
																				userLetterForServiceData.optionalDataform.current.classList.add("was-validated");
																				if (userLetterForServiceData.optionalDataform.current.checkValidity()) {
																					Object.keys(userLetterForServiceData.optionalData).map((key, value) => {
																						if (key.startsWith("Checkbox") && userLetterForServiceData.optionalData[key] !== "true" && userLetterForServiceData.optionalData[key] !== "false") {
																							setUserLettersForServiceData(
																								userLettersForServiceData.map((ul, index) => {
																									if (ul.id !== userLetterForServiceData.id) {
																										return ul;
																									}
																									let newOptionalData = { ...ul.optionalData };
																									newOptionalData[key] = false;
																									return {
																										...ul,
																										optionalData: newOptionalData,
																									};
																								})
																							);
																						}
																					});
																					dispatch(updateLetterById(userLetterForServiceData)).then(() => setDocumentUrl({ ...documentUrl }));
																				}
																			}}>
																			enregistrer
																			<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
																		</button>
																	</footer>
																</form>
															) : (
																""
															)}

															{!R.isNil(userLetterForServiceData.letterTemplate.optionalFiles) && !R.isEmpty(userLetterForServiceData.letterTemplate.optionalFiles) ? (
																<form className="card mb-3" noValidate ref={userLetterForServiceData.optionalFilesform}>
																	<section className="card-body pb-0">
																		<h5 className="h4 text-uppercase text-secondary font-weight-black">Pièces-jointes à fournir</h5>
																		{/* <div className="form-group">
																					<label className="h6 font-weight-bolder my-auto" htmlFor="example">Example success</label>
																					<div className="flex-row">
																						<div className="flex-row mr-2 my-auto align-items-center">
																							<i className="eva eva-file-outline mr-1"></i>
																							<span className="fs-3 o-60">Namepdf-extralong-toread.pfd</span>
																						</div>
																						<button className="btn btn-sm btn-icon p-1 btn-alert-danger ml-1 border-none" id="basic-addon2">
																							<i className="eva eva-close-outline lh-1"></i>
																						</button>
																					</div>
																				</div> */}
																		{Object.keys(userLetterForServiceData.letterTemplate.optionalFiles).map((key) => {
																			return (
																				<div className="row gx-2 mt-2" key={userLetterForServiceData.id + "_optionalFiles_" + key}>
																					<div className="col-12 col-md">
																						<div className="form-group">
																							<label className="h6 font-weight-bolder my-auto" htmlFor={userLetterForServiceData.id + "_" + key}>
																								{userLetterForServiceData.letterTemplate.optionalFiles[key]}
																							</label>
																							{R.isNil(filesToUpload[key]) ? (
																								<div className="custom-file">
																									<input
																										type="file"
																										lang="fr"
																										className="custom-file-input"
																										id={userLetterForServiceData.id + "_" + key}
																										value={filesToUpload[key]}
																										onChange={(e) => {
																											filesToUpload[key] = e.target.files[0];
																											setFilesToUpload({ ...filesToUpload });
																										}}
																									/>
																									<label className="custom-file-label custom-file-light fs-3" htmlFor="customFile">
																										Choisir le fichier...
																									</label>
																								</div>
																							) : (
																								<div className="flex-row">
																									<div className="flex-row mr-2 my-auto align-items-center">
																										<i className="eva eva-file-outline mr-1"></i>
																										<span className="fs-3 o-60">{filesToUpload[key].name}</span>
																									</div>
																									<button
																										className="btn btn-sm btn-icon p-1 btn-alert-danger ml-1 border-none"
																										id="basic-addon2"
																										onClick={(e) => {
																											e.preventDefault();
																											const { [key]: undefined, ...modifiedFiles } = filesToUpload;
																											setFilesToUpload(modifiedFiles);
																										}}>
																										<i className="eva eva-close-outline lh-1"></i>
																									</button>
																								</div>
																							)}

																							<div className="invalid-feedback">
																								<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
																								<span className="align-middle text-dark o-70">Ce champ est requis</span>
																							</div>
																						</div>
																					</div>
																				</div>
																			);
																		})}
																	</section>
																	{/* <hr className="my-0" /> */}
																	<footer className="card-footer text-right">
																		<button
																			className="btn btn-sm btn-alert-info border-none loading-btn"
																			onClick={(e) => {
																				e.preventDefault();
																				userLetterForServiceData.optionalFilesform.current.classList.add("was-validated");
																				let fileUploadPromises = [];
																				Object.keys(filesToUpload).map((key) => {
																					if (R.isNil(filesToUpload[key].fileName)) fileUploadPromises.push(dispatch(uploadDocument(userId, key, filesToUpload[key])));
																				});

																				Promise.all(fileUploadPromises).then(() => {
																					dispatch(updateLetterById(userLetterForServiceData)).then(() => setDocumentUrl({ ...documentUrl }));
																				});
																			}}>
																			enregistrer
																			<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
																		</button>
																	</footer>
																</form>
															) : (
																""
															)}
														</div>
													) : (
														""
													)}
												</div>
											);
										})}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer py-3">
							<button type="button" className="btn btn-light mr-2" data-dismiss="modal">
								Fermer
							</button>
							{userLettersForServiceData.filter((u) => u.letterProgressStage === "Created").length > 0 ? (
								(Object.values(lettersChoice).indexOf(undefined) > -1 && R.isEmpty(selectedServiceData.urls)) || currentlyConnectedUserId !== declaringUserId ? (
									<button type="button" disabled={true} className="btn btn-info">
										Valider
									</button>
								) : userLettersForServiceData.some((ul) => isLoading.includes(loadings.UPDATING_USER_LETTER + "_" + ul.id)) ? (
									<button type="button" className="btn btn-info">
										Valider<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
									</button>
								) : (
									<button
										type="button"
										className="btn btn-info"
										onClick={async (e) => {
											e.preventDefault();
											setIsLoadingLetter(isLoadingLetters.concat(service.title));
											const promises = userLettersForServiceData.reduce(
												(acc, userLetter) => {
													if (lettersChoice[userLetter.id] === true) {
														if (!R.isNil(userLetter.optionalDataform)) {
															userLetter.optionalDataform.current.classList.add("was-validated");
															if (!userLetter.optionalDataform.current.checkValidity()) {
																//userLetter.optionalDataform.current.focus();
																//$('form:first *:input[type!=hidden]:first').focus();
																return acc;
															}
														}
														acc.validate.push(validateLetter(userLetter));
														// acc.validate.push(userLetter);
													} else {
														acc.abandon.push(abandonLetter(userLetter));
														// acc.abandon.push(userLetter);
													}
													return acc;
												},
												{ validate: [], abandon: [] }
											);

											const requests = [...promises.validate, ...promises.abandon];

											let promiseExecution = async () => {
												for (let promise of requests) {
													await dispatch(promise);
												}
											};

											//await Promise.all([...promises.validate, ...promises.abandon]);
											//#region recursion
											// async function requestRecursion(arrayLetter, callback) {
											// 	if (arrayLetter.length <= 0) return;
											// 	await dispatch(callback(arrayLetter.slice(0, 1)[0]));
											// 	await requestRecursion(arrayLetter.slice(1, arrayLetter.length), callback);
											// }
											// await requestRecursion(promises.validate, validateLetter);
											// await requestRecursion(promises.abandon, abandonLetter);

											// userLettersForServiceData.map((userLetter) => {
											// 	if (lettersChoice[userLetter.id] === true) {
											// 		if (!R.isNil(userLetter.optionalDataform)) {
											// 			userLetter.optionalDataform.current.classList.add('was-validated');
											// 			if (!userLetter.optionalDataform.current.checkValidity()) {
											// 				//userLetter.optionalDataform.current.focus();
											// 				//$('form:first *:input[type!=hidden]:first').focus();
											// 				return;
											// 			}
											// 		}
											// 		dispatch(validateLetter(userLetter));
											// 	} else {
											// 		dispatch(abandonLetter(userLetter));
											// 	}
											// });
											//#endregion
											promiseExecution().then(() => {
												if (service.serviceDatas.length > service.serviceDatas.indexOf(selectedServiceData) + 1) {
													const nextServiceData = service.serviceDatas[service.serviceDatas.indexOf(selectedServiceData) + 1];
													setSelectedServiceData(nextServiceData);
													setElementOnFocus(service.serviceDatas.indexOf(nextServiceData));
												} else {
													$("#validation").modal("toggle");
												}
												setIsLoadingLetter([]);
											});
										}}>
										Valider
									</button>
								)
							) : (
								""
							)}
						</div>
					</div>
				) : (
					""
				)}
			</div>
		</div>
	);
};
